// 定义的模块User
const moduleUser = {
  namespaced:true ,
  state: {
    token : localStorage.token ,
    goods_visible : localStorage.goods_visible ,
    inventory_visible : localStorage.inventory_visible ,
    goods_num : localStorage.goods_num ,
    bcm_minutes : localStorage.bcm_minutes ,
    minutes : localStorage.minutes ,
    presale_minutes : localStorage.presale_minutes ,
    user : localStorage.user ,
    activity_bcm_status : localStorage.activity_bcm_status ,
    bcm_status : localStorage.bcm_status,
    wxkfurl : localStorage.wxkfurl,
    priceShow : localStorage.priceShow,
    discount_status : localStorage.discount_status
  },
  mutations: {
    refresh( state ){
      state.token = localStorage.token
      state.goods_visible = localStorage.goods_visible
      state.inventory_visible = localStorage.inventory_visible
      state.goods_num = localStorage.goods_num
      state.bcm_minutes = localStorage.bcm_minutes
      state.minutes = localStorage.minutes
      state.presale_minutes = localStorage.presale_minutes
      state.user = localStorage.user
      state.activity_bcm_status = localStorage.activity_bcm_status
      state.bcm_status = localStorage.bcm_status
      state.wxkfurl = localStorage.wxkfurl
      state.priceShow = localStorage.priceShow
      state.discount_status = localStorage.discount_status
    }
  },
  getters: {

  },
  actions: {

  }
};

export default moduleUser
